import { EventToCanvas } from "./EventToCanvas";
import { prepHandleEvent } from "./prepHandleEvent";

export function handleDragEnter(event) {
  var canvas = document.getElementById("basecanvas");
  var rect = canvas.getBoundingClientRect();
  var p = EventToCanvas(event, rect.left, rect.top);

  var myApp = prepHandleEvent(this, false, null, null);
  if (myApp == null) return;
  myApp.StartDragAndDrop(event, p.x, p.y);
  event.preventDefault();
  event.stopPropagation();
}
